import React from 'react'
import './index.scss'

interface WorkMergeReasonProps {
    reason?: string
}

const WorkMergeReason = ({ reason }: WorkMergeReasonProps) => (
    <div className="work-merge-reason">
        <header>Reason (optional)</header>
        <p>{reason ? reason : 'No reason provided.'}</p>
    </div>
)

export default WorkMergeReason
